import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home.vue";
import Secure from "@/components/Secure.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/secure",
      name: "Secure",
      component: Secure
    }
  ]
});
